import React, { useCallback } from 'react';
import cn from 'classnames';
import TravellerComponent from '@websky/core/src/Traveller/components/Traveller';
import { TravellerFields } from '@websky/core/src/TravellerForm/types';
import css from './Traveller.css';
const Traveller = props => {
    const fieldValueByName = (traveller, type) => {
        var _a;
        return (_a = traveller.values.find(field => field.name === type)) === null || _a === void 0 ? void 0 : _a.value;
    };
    const renderIcon = useCallback((traveller) => {
        var _a, _b;
        if (traveller && traveller.id !== '0') {
            const name = `${((_a = fieldValueByName(traveller, TravellerFields.FirstName)) === null || _a === void 0 ? void 0 : _a[0]) || ''}${((_b = fieldValueByName(traveller, TravellerFields.LastName)) === null || _b === void 0 ? void 0 : _b[0]) || ''}`;
            return React.createElement("div", { className: css.icon }, name);
        }
        return React.createElement("div", { className: cn(css.icon, css.icon_empty) });
    }, []);
    return React.createElement(TravellerComponent, Object.assign({}, props, { renderIcon: renderIcon }));
};
export default Traveller;
